import React from "react";

import "./Scripts.css";
import Button from "react-bootstrap/Button";
import axios from "axios";
import FormControl from "react-bootstrap/FormControl";

class Scripts extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      orderNumbers: "",
      resetShiphawkOrdersCompleted: false,
      newSku: "",
      addSkuCompleted: false,
      skuError: "",
      syncOrdersToSheetsCompleted: false,
    };
  }

  addWupToBidSheet = async () => {
    try {
      await axios.post("/api/scripts/reset_shiphawk_orders", {
        order_numbers: this.state.orderNumbers,
      });

      this.setState({ resetShiphawkOrdersCompleted: true });
    } catch (e) {
      // TODO: add error state
    }
  };

  addNewSku = async () => {
    if (!this.state.newSku.includes("/")) {
      this.setState({
        skuError: "Value must be in the format NEWSKU/OLDSKU",
      });
      return;
    }

    try {
      await axios.post("/api/components", {
        sku: this.state.newSku,
      });

      this.setState({
        addSkuCompleted: true,
        skuError: "",
        newSku: "",
      });
    } catch (e) {
      this.setState({ skuError: "Error adding SKU: " + e.message });
    }
  };

  syncOrdersToSheets = async () => {
    try {
      await axios.post("/api/scripts/sync_orders_to_sheets");

      this.setState({ syncOrdersToSheetsCompleted: true });
    } catch (e) {
      // TODO: add error state
    }
  };

  render() {
    return (
      <div className="scripts-container">
        <div className="scripts-subtitle">Reset Shiphawk Orders</div>

        <div className="scripts-section">
          <label>(One order number per line)</label>
          <FormControl
            as="textarea"
            rows={3}
            className="announcements-field-order"
            onChange={(e) => this.setState({ orderNumbers: e.target.value })}
          />
          <Button
            className="scripts-button"
            variant="info"
            onClick={this.addWupToBidSheet}
          >
            {this.state.resetShiphawkOrdersCompleted ? "Done!" : "Run"}
          </Button>
        </div>

        <div className="scripts-subtitle">Add New SKU</div>

        <div className="scripts-section">
          <label>Example: A990106B001A/EZNETTUTOR</label>
          <FormControl
            type="text"
            value={this.state.newSku}
            style={{ width: "300px" }}
            onChange={(e) =>
              this.setState({
                newSku: e.target.value,
                addSkuCompleted: false,
                skuError: "",
              })
            }
          />
          {this.state.skuError && (
            <div
              className="error-message"
              style={{ color: "red", marginTop: "5px" }}
            >
              {this.state.skuError}
            </div>
          )}
          <Button
            className="scripts-button"
            variant="info"
            onClick={this.addNewSku}
          >
            {this.state.addSkuCompleted ? "Done!" : "Run"}
          </Button>
        </div>

        <div className="scripts-subtitle">Sync Orders to Google Sheets</div>

        <div className="scripts-section">
          <label>Completes in about 5 minutes</label>
          <Button
            className="scripts-button"
            variant="info"
            onClick={this.syncOrdersToSheets}
          >
            {this.state.syncOrdersToSheetsCompleted ? "Done!" : "Run"}
          </Button>
        </div>
      </div>
    );
  }
}

export default Scripts;
